import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField, Box, Alert } from '@mui/material';
import DatePickerComponent from '../../../common/components/DatePickerComponent';
import { PAYMENT_STRINGS, PAYMENT_ERRORS } from '../../../common/constants/customerModule/paymentConstants';

const PaymentConfirmModal = ({ open, onClose, selectedGuid, mode = 'now' }) => {
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState(null);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const reset = () => {
    setAmount('');
    setDate(null);
    setError('');
    setIsSubmitting(false);
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSubmit = async () => {
    setError('');
    if (mode === 'now') {
      const val = parseFloat(amount);
      if (isNaN(val) || val <= 0) {
        setError(PAYMENT_ERRORS.ENTER_VALID_AMOUNT);
        return;
      }
    } else {
      if (!date) {
        setError(PAYMENT_ERRORS.SELECT_DATE);
        return;
      }
      const val = parseFloat(amount);
      if (isNaN(val) || val <= 0) {
        setError(PAYMENT_ERRORS.ENTER_VALID_AMOUNT);
        return;
      }
    }

    setIsSubmitting(true);
    try {
      // TODO: call backend API to take or schedule payment
      // Simulate async action
      await new Promise((r) => setTimeout(r, 700));
      handleClose();
    } catch (err) {
      setError(PAYMENT_ERRORS.OPERATION_FAILED);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={!!open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{mode === 'now' ? PAYMENT_STRINGS.CONFIRM_PAYMENT_TITLE : PAYMENT_STRINGS.SCHEDULE_PAYMENT_TITLE}</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 1 }}>
          {mode === 'now' ? PAYMENT_STRINGS.CONFIRM_NOW_MESSAGE : PAYMENT_STRINGS.CONFIRM_SCHEDULE_MESSAGE}
        </Typography>
        <Typography variant="caption">{PAYMENT_STRINGS.SELECTED_CUSTOMER_ID} {selectedGuid}</Typography>

        <Box sx={{ mt: 2 }}>
          {error && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}
          {mode === 'now' ? (
            <TextField
              label={PAYMENT_STRINGS.AMOUNT_LABEL}
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              fullWidth
              size="small"
              type="number"
              inputProps={{ min: '0', step: '0.01' }}
            />
          ) : (
            <>
              <DatePickerComponent label={PAYMENT_STRINGS.PAYMENT_DATE} date={date} onDateChange={setDate} fullWidth />
              <Box sx={{ mt: 2 }}>
                <TextField
                  label={PAYMENT_STRINGS.AMOUNT_LABEL}
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  fullWidth
                  size="small"
                  type="number"
                  inputProps={{ min: '0', step: '0.01' }}
                />
              </Box>
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isSubmitting}>{PAYMENT_STRINGS.CANCEL}</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={isSubmitting}>
          {isSubmitting ? PAYMENT_STRINGS.SUBMIT + '...' : PAYMENT_STRINGS.SUBMIT}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentConfirmModal;